<template>
    <div class="table_container">
        <common-layout>
            <div slot="header">
                <h3>科技创新券管理</h3>
            </div>
            <div slot="container">
                <!-- <div class="handle-box">
                    <el-input style="width:30%;margin:0 10px" placeholder="视频关键词" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-select>
                        <el-option value label="全部"></el-option>
                        <el-option value="1" label="学习课程"></el-option>
                        <el-option value="2" label="点播课程"></el-option>
                    </el-select>
                </div> -->
                <div id="table">
                    <el-table ref="multipleTable" :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }" :data="tableData" style="width: 100%" type="index" >
                        <el-table-column type="index" width="100" label="序号" align="center"></el-table-column>
                        <el-table-column prop="title" label="名称" align="center"></el-table-column>
                        <el-table-column prop="createTime" label="添加日期" align="center"></el-table-column>
                        <el-table-column prop="creatorName" label="操作员" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="120">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination">
                    <div class="grid-content bg-purple-light">
                        <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next,jumper"
                            :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
                    </div>
                </div>
            </div>
        </common-layout>
        <el-dialog
            title="修改科技创新券管理"
            :visible.sync="dialogFormVisible"
            :close-on-click-modal="false"
            width="50%"
            >
            <el-form :model="form" ref="form">
                <el-form-item
                    label="标题"
                    label-position="top"
                >
                    <el-input
                        v-model="form.title"
                        autocomplete="off"
                        placeholder="请输入标题"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label-position="top"
                    label="发放数（按地区） (地区顺序：酒泉|嘉峪关|张掖|金昌|武威|白银|兰州|临夏|定西|天水|陇南|平凉|庆阳|甘南)"
                >
                    <el-input
                    type="textarea"
                    v-model="form.numberOfIssued"
                    :rows="2"
                    placeholder="请输入发放数（按地区） (地区顺序：酒泉|嘉峪关|张掖|金昌|武威|白银|兰州|临夏|定西|天水|陇南|平凉|庆阳|甘南)"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="兑换数(按地区) (地区顺序：酒泉|嘉峪关|张掖|金昌|武威|白银|兰州|临夏|定西|天水|陇南|平凉|庆阳|甘南)"
                    label-position="top"
                >
                <el-input
                    type="textarea"
                    v-model="form.exchangeNumber"
                    :rows="2"
                    placeholder="请输入兑换数(按地区) (地区顺序：酒泉|嘉峪关|张掖|金昌|武威|白银|兰州|临夏|定西|天水|陇南|平凉|庆阳|甘南)"
                   >
                    </el-input>
                </el-form-item>
                <div class="flex_flow"> 
                    <el-form-item
                        label="申领、发放年份"
                        label-position="top"
                        class="flex_flow_item"
                    >
                    <el-input
                        type="textarea"
                        v-model="form.claimOrIssueYear"
                        :rows="2"
                        placeholder="请输入申领、发放年份"
                    >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="年份发放"
                        label-position="top"
                        class="flex_flow_item"

                    >
                    <el-input
                        type="textarea"
                        v-model="form.issueYear"
                        :rows="2"
                        placeholder="请输入年份发放"
                    >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="年份领取"
                        label-position="top"
                        class="flex_flow_item"

                    >
                    <el-input
                        type="textarea"
                        v-model="form.issueYear"
                        :rows="2"
                        placeholder="请输入年份领取"
                    >
                        </el-input>
                    </el-form-item>
                </div>
                <div class="flex_flow"> 
                    <el-form-item
                        label="使用活跃数(按年份)"
                        label-position="top"
                        class="flex_flow_item"
                    >
                    <el-input
                        type="textarea"
                        v-model="form.activeUsage"
                        :rows="2"
                        placeholder="请输入使用活跃数(按年份)"
                    >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="兑换活跃"
                        label-position="top"
                        class="flex_flow_item"

                    >
                    <el-input
                        type="textarea"
                        v-model="form.activeExchange"
                        :rows="2"
                        placeholder="请输入兑换活跃"
                    >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="用户活跃度 (数据间用竖线分隔，这里显示的是百分比，如：33|35|40|55)"
                        label-position="top"
                        class="flex_flow_item align_left"

                    >
                    <el-input
                        type="textarea"
                        v-model="form.userActivity"
                        :rows="2"
                        placeholder="请输入用户活跃度 (数据间用竖线分隔，这里显示的是百分比，如：33|35|40|55)"
                    >
                        </el-input>
                    </el-form-item>
                </div>
                <el-form-item
                    label-position="top"
                    label="使用、兑现及用户活跃度情况年份 (数据顺序如：2019|2020|2021，跟使用、兑现及用户活跃度情况对应)"
                >
                    <el-input
                    type="textarea"
                    v-model="form.useOrCashYear"
                    :rows="2"
                    placeholder="请输入使用、兑现及用户活跃度情况年份 (数据顺序如：2019|2020|2021，跟使用、兑现及用户活跃度情况对应)"
                   >
                    </el-input>
                </el-form-item>
                <div class="flex_flow"> 
                    <el-form-item
                        label="服务类型"
                        label-position="top"
                        class="flex_flow_item"
                    >
                    <el-input
                        type="textarea"
                        v-model="form.serviceType"
                        :rows="2"
                        placeholder="请输入服务类型"
                    >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="服务企业数"
                        label-position="top"
                        class="flex_flow_item"

                    >
                    <el-input
                        type="textarea"
                        v-model="form.numberOfServiceCompanies"
                        :rows="2"
                        placeholder="请输入服务企业数"
                    >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="服务次数"
                        label-position="top"
                        class="flex_flow_item"

                    >
                    <el-input
                        type="textarea"
                        v-model="form.numberOfServices"
                        :rows="2"
                        placeholder="请输入服务次数"
                    >
                        </el-input>
                    </el-form-item>
                </div>
                <div class="flex_flow"> 
                    <el-form-item
                        label="服务成果数"
                        label-position="top"
                        class="flex_flow_item2"
                    >
                    <el-input
                        type="textarea"
                        v-model="form.numberOfServiceResults"
                        :rows="2"
                        placeholder="请输入服务成果数"
                    >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="补贴金额"
                        label-position="top"
                        class="flex_flow_item2"

                    >
                    <el-input
                        type="textarea"
                        v-model="form.subsidyAmount"
                        :rows="2"
                        placeholder="请输入补贴金额"
                    >
                        </el-input>
                    </el-form-item>
                </div>
                <div class="flex_flow"> 
                    <el-form-item
                        label="专项资金分类金额"
                        label-position="top"
                        class="flex_flow_item2"
                    >
                    <el-input
                        type="textarea"
                        v-model="form.amountOfSpecialFundsByCategory"
                        :rows="2"
                        placeholder="请输入专项资金分类金额"
                    >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="专项资金总额"
                        label-position="top"
                        class="flex_flow_item2"

                    >
                    <el-input
                        type="textarea"
                        v-model="form.totalAmountOfSpecialFunds"
                        :rows="2"
                        placeholder="请输入专项资金总额"
                    >
                        </el-input>
                    </el-form-item>
                </div>
                <el-form-item
                    label-position="top"
                    label="资金使用说明"
                >
                    <el-input
                    type="textarea"
                    v-model="form.instructionsForUseOfFunds"
                    :rows="2"
                    placeholder="请输入资金使用说明"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label-position="top"
                    label="服务内容（轮动显示） (每一条信息以|分隔)"
                >
                    <el-input
                    type="textarea"
                    v-model="form.serviceContent"
                    :rows="4"
                    placeholder="请输入服务内容（轮动显示） (每一条信息以|分隔)"
                   >
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onSubmit">修 改</el-button>
                <el-button type="warning" @click="dialogFormVisible=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CommonLayout from "../../../components/common-layout.vue";
export default {
    components: {
        CommonLayout,
    },
    data() {
        return {
            tableData: [], //列表数据
            total: 10, //总页数
            current_page: 1, //当前页
            per_page: 20, //每页条数
            dialogFormVisible: false,
            form: {},
            formLabelWidth: "120px"
        };
    },
    created() {
        this.getData();
    },
    computed: {
    },
    methods: {
        onSubmit() {
            let params = {
                ...this.form,
                isShow: 1,
                id: this.form.id
            }
            this.http.put('apij2/admin-api/voucher/large-screen-technology-innovation-vouchers-management/update', params).then((response) => {
                if (response.code == 0) {
                    this.$message.success('修改成功');
                    this.getData()
                    this.dialogFormVisible = false;
                }
            });
        },
        handleEdit(item) {
            this.form = {}
            this.$nextTick(() => {
                this.form = {...item};
                this.dialogFormVisible = true;
            });
        },
        //获取列表数据
        getData() {
            let params = {
                page: this.current_page,
                pageSize: this.per_page,
            }
            this.http.post('apij2/admin-api/voucher/large-screen-technology-innovation-vouchers-management/page', params).then((response) => {
                this.tableData = response.data.data;
                this.total = response.data.total; //总页数
                this.per_page = response.data.per_page;
                this.current_page = response.data.current_page;
            });
        },
        //选择页码
        handleCurrentChange(e) {
            this.current_page = e;
            this.getData();
        },
    },
};
</script>
<style lang="scss" scoped>
* {
    word-break: normal;
}

.table_container {
    height: 100%;
    text-align: left;

    .handle-box {
        .handle-input {
            /deep/.el-input__suffix {
                margin-right: 10px;
            }
        }
    }

    #table {
        margin-top: 20px;
        border: 1px solid #eef1f6;

        /deep/ th {
            // background-color: #eef1f6 !important;
            // color: #000;
        }

        /deep/ td {}

        /deep/ .cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            img {
                max-width: 100px;
                max-height: 100%;
                width: auto;
                height: auto;
            }
        }

        p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .pagination {
        margin-top: 10px;
    }

    /deep/ .el-dialog__header {
        text-align: center !important;
    }
}

.mess {
    color: red;
    margin-left: 20px;
}
/deep/ .el-dialogFormVisible__header{
		border-bottom: 1px solid #ccc;
		font-size: 20px;
		font-weight: 500;
		padding-bottom: 20px;
		margin-bottom: 10px;
	}
    /deep/ .el-dialogFormVisible__body{
        padding: 20px;
    }
    .flex_flow{
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
    }
    .flex_flow_item{
        width: calc((100% - 20px)/3);
    }
    .align_left {
        /deep/ .el-form-item__label{
            text-align: left;
            line-height: 20px;
        }
    }
    .flex_flow_item2{
        width: calc((100% - 20px)/2);
    }
</style>
